import axios from "../shared/axios";
import * as events from './events';

export function getCompensationQuote(quotationid) {
  return axios.get(`/api/Quotation/GetQuotation?quotationid=${quotationid}`);
}
export function saveCompensationQuote(data) {
  return new Promise((resolve, reject) => {
    axios
      .post(`/api/Quotation/SaveQuotation`, data)
      .then((result) => {
        events.onNotification_CREATED();
        resolve(result);
      })
      .catch((error) => reject(error));
  });
}
export function updateCompensationQuote(data) {
  return new Promise((resolve, reject) => {
    axios
      .post(`/api/Quotation/Update`, data)
      .then((result) => {
        switch (data.actioncode) {
          case 'QUOTE_SAVE_DRAFT':
            events.onNotification_DRAFT_SAVED();
            break;
          case 'QUOTE_COMMUNICATE':
            events.onNotification_COMMUNICATED();
            break;
          case 'QUOTE_REPLY_DRAFT':
            events.onNotification_REPLY_DRAFT_SAVED();
            break;
          case 'QUOTE_REPLY_SEND':
            events.onNotification_REPLY_SENT();
            break;
          default:
            alert('Unknown action code!');
            break;
        }
        resolve(result);
      })
      .catch((error) => reject(error));
  });
}
export function saveQuotationActivity(data) {
  return axios.post(`/api/Quotation/SaveQuotationActivity`, data);
}
export function getQuotationActivities(
  companyid,
  projectid,
  contractid,
  quotationid,
  actionType
) {
  return axios.post(
    `/api/Quotation/LoadQuotationActivitiesList?companyid=${companyid}&projectid=${projectid}&contractid=${contractid}&quotationid=${quotationid}&actiontype=${actionType}`
  );
}

export function getQuotationOtherPriceChanges(
  companyid,
  projectid,
  contractid,
  quotationid,
  actionType
) {
  return axios.post(
    `/api/Quotation/LoadQuotationOtherPriceChangeList?companyid=${companyid}&projectid=${projectid}&contractid=${contractid}&quotationid=${quotationid}&actiontype=${actionType}`
  );
}

export function getQuotes(companyid, projectid, contractid) {
  return axios.post(
    `/api/Quotation/LoadAllQuotationsList?companyid=${companyid}&projectid=${projectid}&contractid=${contractid}`
  );
}

export function getQuotesReduced(companyid, contractid, cenid) {
  return axios.post(`/api/Quotation/RegisterList`, null, { params: { companyid, contractid, compensationeventid: cenid } });
}

export function deleteQuoteDraft(quotationid) {
  return new Promise((resolve, reject) => {
    axios.post(`/api/Quotation/DeleteDraft?quotationid=${quotationid}`)
      .then(result => {
        events.onNotification_DELETED();
        resolve(result);
      })
      .catch(error => reject(error));
  })
}


export function importQuotations(data) {
  return new Promise(async (resolve, reject) => {
    try {
      const result = await axios.post(`/api/Quotation/Import`, data);
      events.onNotification_CREATED();
      resolve(result);
    }
    catch (err) {
      reject(err)
    }
  });
}

export function deleteQuotationDrafts(data) {
  return new Promise(async (resolve, reject) => {
    try {
      const result = await axios.delete(`/api/Quotation/BulkDeleteDraft`, { data: data });
      events.onNotification_DELETED();
      resolve(result);
    }
    catch (err) {
      reject(err)
    }
  });
}

export function communicateQuotationDrafts(data) {
  return new Promise(async (resolve, reject) => {
    try {
      const result = await axios.put(`/api/Quotation/BulkCommunicate`, data);
      events.onNotification_COMMUNICATED();
      resolve(result);
    }
    catch (err) {
      reject(err)
    }
  });
}

export function getAcceptedQuotation(compensationeventid) {
  return axios.get(`/api/Quotation/GetAcceptedQuotation`, { params: { compensationeventid } });
}